'use strict';
export default function routes($stateProvider) {
    'ngInject';
    $stateProvider
        .state('quality', {
        url: '/quality',
        template: require('./template.html'),
        controller: 'QualityController',
        controllerAs: 'vm',
        abstract: true
    })
        .state('quality.about-the-eqp', {
        url: '/about-the-eqp',
        template: require('./about-the-eqp/template.html'),
        controller: function ($scope) {
        }
    })
        .state('quality.eqp-partners', {
        url: '/eqp-partners',
        template: require('./eqp-partners/template.html'),
        controller: 'EqpPartnersController',
        controllerAs: 'vm'
    })
        .state('quality.shop-quality-partners', {
        url: '/shop-quality-partners',
        template: require('./shop-quality-partners/template.html'),
        controller: function ($scope) {
        }
    });
}
//# sourceMappingURL=quality.routes.js.map